import React from "react";
import UserPublicationFavoriteRecord from "models/view-models/user-publication-favorite-record";
import PublicationCard from "molecules/cards/publication-card";
import DashboardPublicationsListItem from "molecules/dashboard-publications-list/dashboard-publications-list-item";
import { ViewModes } from "models/enumerations/view-modes/view-modes";
import { PublicationSortItem } from "../../utilities/hooks/domain/publications/use-publication-sort-items";

export interface PublicationDisplayListItemProps {
    cssClassModifier?: string;
    favorites?: UserPublicationFavoriteRecord[];
    onChangeFavorites: (newValue: Array<UserPublicationFavoriteRecord>) => void;
    publicationSortItem: PublicationSortItem;
    view: ViewModes;
}

const PublicationDisplayListItem = (props: PublicationDisplayListItemProps) => {
    const {
        cssClassModifier,
        favorites = [],
        onChangeFavorites,
        publicationSortItem,
        view,
    } = props;

    if (view === ViewModes.Grid) {
        return (
            <PublicationCard
                favorites={favorites}
                onChangeFavorites={onChangeFavorites}
                publication={publicationSortItem.publication}
            />
        );
    }

    return (
        <DashboardPublicationsListItem
            cssClassModifier={cssClassModifier}
            favorites={favorites}
            onChangeFavorites={onChangeFavorites}
            publication={publicationSortItem.publication}
        />
    );
};

export default PublicationDisplayListItem;
